import React, { Fragment } from 'react';
import { withStyles } from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import WaveTextField from '../form/WaveTextField';

const styles = theme => ({
  fields: {
    marginBottom: theme.typography.pxToRem(10)
  }
});

class DepartmentForm extends React.Component {

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <Grid
          container
          className={classes.fields}
          justifyContent="space-between"
        >
          <Grid size={12}>
            <WaveTextField
              label="Department Code"
              {...this.props.makeFieldProps('code')}
            />
          </Grid>
          <Grid size={12}>
            <WaveTextField
              label="Department Name"
              {...this.props.makeFieldProps('name')}
            />
          </Grid>
        </Grid>
      </Fragment>
    );
  }

}

export default withStyles(DepartmentForm, styles, { withTheme: true });
